var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCameraLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19655)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0989 13.1692C18.9662 11.9301 20.3789 11 22.1 11H26C27.6744 11 29.1252 11.7907 30.0281 13.2094L30.0407 13.2299L31.7196 16H34.5C37.0868 16 39.216 18.0791 39.1 20.7257V32.5C39.1 35.1075 37.0075 37.2 34.4 37.2H13.6C10.9925 37.2 8.90002 35.1075 8.90002 32.5V20.7C8.90002 18.0925 10.9925 16 13.6 16H16.3804L18.0593 13.2299C18.0718 13.2092 18.085 13.189 18.0989 13.1692ZM19.9207 14.4033L17.9407 17.6701C17.7414 17.9991 17.3847 18.2 17 18.2H13.6C12.2075 18.2 11.1 19.3075 11.1 20.7V32.5C11.1 33.8925 12.2075 35 13.6 35H34.4C35.7925 35 36.9 33.8925 36.9 32.5V20.7C36.9 20.6817 36.9005 20.6634 36.9014 20.6451C36.9684 19.3056 35.9037 18.2 34.5 18.2H31.1C30.7154 18.2 30.3587 17.9991 30.1593 17.6701L28.166 14.3812C27.6688 13.606 26.9219 13.2 26 13.2H22.1C21.2318 13.2 20.4529 13.6586 19.9207 14.4033Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1 21.7C21.9461 21.7 20.2 23.4461 20.2 25.6C20.2 27.7539 21.9461 29.5 24.1 29.5C26.2539 29.5 28 27.7539 28 25.6C28 23.4461 26.2539 21.7 24.1 21.7ZM18 25.6C18 22.2311 20.7311 19.5 24.1 19.5C27.4689 19.5 30.2 22.2311 30.2 25.6C30.2 28.9689 27.4689 31.7 24.1 31.7C20.7311 31.7 18 28.9689 18 25.6Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 23.3004C34.5389 23.3004 35.3 22.5393 35.3 21.6004C35.3 20.6615 34.5389 19.9004 33.6 19.9004C32.6611 19.9004 31.9 20.6615 31.9 21.6004C31.9 22.5393 32.6611 23.3004 33.6 23.3004Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2,
    height: 26.2,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraLight);
export default __webpack_public_path__ + "static/media/icon_camera_light.d676d687.svg";
export { ForwardRef as ReactComponent };